module.exports = "<div><a ng-click=\"loadNode(node)\"><i class=\"icon\" ng-class=\"getIcon(node)\"></i> {{ node.name || '/' }}</a><ul ng-if=\"tree\"><li ng-repeat=\"node in tree\"><sc-file-tree-node filter=\"filter\" node=\"node\" path=\"getPath(node, path)\"></sc-file-tree-node></li></ul></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/filetree/files-tree-node.component.html
// module id = 1020
// module chunks = 0